<head>
  <title>{{'APP_NAME'|translate}}</title>
</head>
<div class="app-body" *ngIf="!token || changePass">
  <canvas #bgCanvas class="login-bg" aria-hidden="true"></canvas>
  <!-- Pinned to the page corner rather than the card footer, so it stays put
       whichever form (credentials or OTP) the card is showing. -->
  <button (click)="toggleTheme();" class="btn theme-toggle" role="switch" [attr.aria-checked]="theme === 'dark'"
    title="{{(theme === 'dark' ? 'LIGHT_THEME' : 'DARK_THEME') | translate}}"
    [attr.aria-label]="(theme === 'dark' ? 'LIGHT_THEME' : 'DARK_THEME') | translate">
    <i class="fa" [ngClass]="theme === 'dark' ? 'fa-sun-o' : 'fa-moon-o'"></i>
  </button>
  <main class="main d-flex align-items-center mx-auto">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 d-flex justify-content-center">
          <div class="card-group">
            <div class="card">

              <div class="card-header bg-white">
                <img class="d-block mx-auto" src="./assets/images/logo/petiak.png" alt="Petiak">
                <h1 class="title">{{'APP_NAME' | translate}}</h1>
              </div>

              <div class="card-body">
                <div class="card-block">
                  <form *ngIf="!otp" class="form-horizontal form-simple">
                    <fieldset class="form-group position-relative has-icon-left mb-1">
                      <input type="text" #usernameInput class="form-control form-control-lg" style="direction: ltr;"
                        id="user-name"
                        placeholder="{{'NATIONAL_CODE'|translate}} {{'OR'|translate}} {{'EMAIL' | translate}} {{'OR'|translate}} {{'MOBILE'|translate}}"
                        required autofocus [(ngModel)]="dataUser" [ngModelOptions]="{standalone: true}">
                      <div class="form-control-position">
                        <i class="fa fa-user"></i>
                      </div>
                    </fieldset>
                    <fieldset *ngIf="!changePass" class="form-group position-relative has-icon-left">
                      <input type="password" class="form-control form-control-lg" style="direction: ltr;"
                        id="user-password" placeholder="{{'PASSWORD' | translate}}" required [(ngModel)]="dataPass"
                        [ngModelOptions]="{standalone: true}">
                      <div class="form-control-position">
                        <i class="fa fa-lock"></i>
                      </div>
                    </fieldset>
                    <!--  <fieldset *ngIf="changePass" class="form-group position-relative has-icon-left">
                      <input type="password" class="form-control form-control-lg" style="direction: ltr;"
                        id="new-user-password" placeholder="{{'NEW_PASSWORD' | translate}}" [(ngModel)]="newdataPass"
                        [ngModelOptions]="{standalone: true}">
                      <div class="form-control-position">
                        <i class="fa fa-lock"></i>
                      </div>
                    </fieldset>
                    <fieldset *ngIf="changePass" class="form-group position-relative has-icon-left">
                      <input type="password" class="form-control form-control-lg" style="direction: ltr;"
                        id="retype-user-password" placeholder="{{'REPEAT_NEW_PASSWORD' | translate}}"
                        [(ngModel)]="retypeDataPass" [ngModelOptions]="{standalone: true}">
                      <div class="form-control-position">
                        <i class="fa fa-lock"></i>
                      </div>
                    </fieldset> -->
                    <div>

                      <button class="btn btn-primary btn-lg btn-block" (click)="login()">
                        {{'LOGIN' | translate}}
                      </button>
                    </div>

                    <!-- <button *ngIf="changePass" type="submit" class="btn btn-primary btn-lg btn-block"
                      (click)="changePassword()">

                      <i class="icon-unlock2"></i>{{'OK' | translate}}</button> -->

                  </form>
                  <form *ngIf="otp" class="form-horizontal form-simple">
                    <ngb-alert *ngIf="otpMobile" type="info" [dismissible]="false">
                      {{'OTP_SENT' | translate}} <span dir="ltr">{{otpMobile}}</span>
                    </ngb-alert>

                    <fieldset class="form-group mb-1">
                      <label class="otp-label" for="otp-0">
                        <i class="fa fa-key"></i> {{'OTP'|translate}}
                      </label>
                      <!-- The code is always 4 digits, so it gets one box per digit. -->
                      <div class="otp-boxes" dir="ltr" (paste)="onOtpPaste($event)">
                        <input *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIndex" #otpBox
                          type="text" inputmode="numeric" class="form-control form-control-lg otp-box" [id]="'otp-' + i"
                          maxlength="1" autocomplete="one-time-code"
                          [attr.aria-label]="('OTP'|translate) + ' ' + (i + 1)" [value]="digit"
                          (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)"
                          (focus)="onOtpSelect($event)" (click)="onOtpSelect($event)">
                      </div>
                    </fieldset>
                    <button *ngIf="!changePass" class="btn btn-primary btn-lg btn-block" (click)="login()">
                      {{'OK' | translate}}
                    </button>
                  </form>
                </div>
              </div>

              <div class="card-footer bg-white">
                <div *ngIf="!otp && !changePass" class="d-flex justify-content-between">
                  <button class="btn btn-link btn-lg" (click)="sendOTP()">
                    {{'OTP_LOGIN' | translate}}
                  </button>
                  <!-- <button *ngIf="debt && dataUser" (click)="redirectPay()" class="btn btn-link btn-lg">
                    {{'PAY_BASKET' | translate}}
                  </button> -->

                  <button (click)="toggleLang();" class="btn btn-link btn-lg">
                    {{'CHANGE_LANG' | translate}}
                  </button>

                </div>

                <div *ngIf="otp" class="d-flex justify-content-between">
                  <!-- <ul>
                    <li> -->
                  <button [disabled]="!enableResendOTP" class="btn btn-link btn-lg" (click)="sendOTP()">
                    {{'OTP_RESEND' | translate}} <span *ngIf="toResendOTP > 0">({{ toResendOTP | secondToTimeStructured
                      }})</span>
                  </button>
                  <!-- </li>
                    <li> -->
                  <button (click)="toggleLang();" class="btn btn-link btn-lg">
                    {{'CHANGE_LANG' | translate}}
                  </button>
                  <!-- </li>
                  </ul> -->
                </div>

                <!-- <ng-template #forgetForm let-c="close" let-d="dismiss">
                  <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">
                      {{ 'SEND_PASSWORD' | translate }}
                    </h4>

                    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form class="form-horizontal form-simple">
                      <fieldset class="form-group position-relative has-icon-left mb-1">
                        <input type="text" #usernameInput class="form-control form-control-lg" style="direction: ltr;"
                          id="username"
                          placeholder="{{'NATIONAL_CODE' | translate}} {{'OR' | translate}} {{'NATIONAL_ID' | translate}}"
                          required [(ngModel)]="dataUser" [ngModelOptions]="{standalone: true}">
                        <div class="form-control-position">
                          <i class="fa fa-user"></i>
                        </div>
                      </fieldset>
                      <fieldset class="form-group position-relative has-icon-left mb-1">
                        <input type="text" #usernameInput class="form-control form-control-lg" style="direction: ltr;"
                          id="mobile" placeholder="{{'MOBILE' | translate}}" required [(ngModel)]="dataMobile"
                          [ngModelOptions]="{standalone: true}">
                        <div class="form-control-position">
                          <i class="fa fa-user"></i>
                        </div>
                      </fieldset>
                      <button class="btn btn-primary btn-lg btn-block" (click)="forgetPass()"><i
                          class="icon-unlock2"></i>{{'OK' | translate}}</button>
                    </form>
                  </div>

                </ng-template> -->

              </div>

            </div>
          </div>
        </div>
        <div class="text-center w-100">
          <button *ngIf="isMobile" class="btn btn-link btn-lg" (click)="openMobile()">
            {{'MOBILE_APP' | translate}}
          </button>
        </div>
      </div>
    </div>
  </main>
</div>